import { render } from "./NavBar.vue?vue&type=template&id=440f90f8&scoped=true"
import script from "./NavBar.vue?vue&type=script&lang=js"
export * from "./NavBar.vue?vue&type=script&lang=js"

import "./NavBar.vue?vue&type=style&index=0&id=440f90f8&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\paulinho\\Documents\\GitHub\\liscomp_website_vue3_cli\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-440f90f8"]])

export default __exports__